import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterSSDIPageConciergeCreate = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("ssdi/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ConciergeCreatePage />,
        });
      })
      .catch(reject);
  });
});

export const LazySSDIPageConciergeCreate = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterSSDIPageConciergeCreate />
    </Suspense>
  );
};
